// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import * as CursorSpinner from 'fg-frontend/src/components/CursorSpinner';
import {eshopUserToolsRefresh} from '../webActions/eshopUserToolsRefresh';
import tippy from 'tippy.js';

export default class EshopUserToolsHandler extends WebComponent {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  didMount() {
    this.submitElement = this.element.querySelector('[type="submit"]');
    this.submitElement.addEventListener('click', this.handleSubmit);
  }
  willUnMount() {
    this.submitElement.removeEventListener('click', this.handleSubmit);
  }

  createFormData( element) {
    // pokud jsem v detailu produktu, widget je samostatny `form`, FormData se vezmou z widgetu
    if ( element instanceof HTMLFormElement ) return new FormData(element);

    // pokud jsme v kosiku, widget je uvnitr formu (kosik), FormData musim sestavit
    const inputs = element.querySelectorAll('input');
    const formData = new FormData();
    for (let i = 0; i < inputs.length; ++i) {
      formData.append(inputs[i].name, inputs[i].value);
    }
    return formData;
  };

  handleSubmit(event) {
    const {
      activeClass,
      tooltip,
      jsonUrl,
    } = this.props;

    event.preventDefault();

    const buttonLabel = this.submitElement.querySelector('.button-label');

    const xhr = new XMLHttpRequest();
    const formData = this.createFormData(this.element);
    const requestUrl = this.element.getAttribute('action') || this.element.getAttribute('data-action');
    formData.append(this.submitElement.name, this.submitElement.value);

    CursorSpinner.pushToQueue('eshopUserToolsHandle');

    xhr.onload = () => {
      if (xhr.status == 200) {
        eshopUserToolsRefresh();

        if (this.submitElement.classList.contains(activeClass)) {
          this.submitElement.name = this.submitElement.name.replace('removeItemFromList','addItemToList');
          buttonLabel.innerHTML = this.submitElement.getAttribute('data-default-title');

        } else {
          this.submitElement.name = this.submitElement.name.replace('addItemToList','removeItemFromList');
          buttonLabel.innerHTML = this.submitElement.getAttribute('data-active-title');
        }

        if (tooltip) {
          const xhrJson = new XMLHttpRequest();
          const lang = window.projectConfig.lang;
          xhrJson.onreadystatechange = () => {
            if (xhrJson.readyState == 4 && xhrJson.status == 200) {
              try {
                const json = JSON.parse(xhrJson.responseText);
                this.renderTooltip(json.result);

              } catch (error) {
                throw Error;
              }
            }
          }
          xhrJson.open('post','/qf/'+lang+'/ramjet/include@' + jsonUrl, true);
          xhrJson.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
          xhrJson.send();
        }

        this.submitElement.classList.toggle(activeClass);
      }
      CursorSpinner.removeFromQueue('eshopUserToolsHandle');
    };

    xhr.open('post',requestUrl, true);
    xhr.send(formData);
  }

  renderTooltip(result) {
    this.tip = tippy(this.submitElement, {
      arrow: true,
      theme: 'esp',
      placement: 'top',
      trigger: 'manual',
      allowHTML: true,
      interactive: true,
    });
    this.tip.setContent(result);
    this.tip.show();
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/EshopUserToolsHandler.js